import axios from "axios";

/***
 * 從後端取得產品資訊
 */
export function getServerMultiTourInfoRepository() {
  
  // POST 方法取得最新產品資訊
  // 因需要取得的 query data 過大，所以採用 POST 方法向後端呼叫取得產品
  let _getServerTourResult = async function (api_query_list) {
    let api_url = "/detail/ajaxMultiTour";
    let server_tour_result = {};
    await axios({
      url: api_url,
      method: "POST",
      data: { tour: api_query_list },
    })
      .then((response) => {
        if (response.data.status == "success") {
          server_tour_result = response.data.tour_data;
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return server_tour_result;
  };

  let _getServerTourResultByGetMethod = async function (api_query_list) {
    let api_url = "/detail/ajaxMultiTour?";
    let server_tour_result = {};

    await axios
      .get(api_url + api_query)
      .then((response) => {
        console.log("response", response);
        if (response.data.status == "success") {
          server_tour_result = response.data.tour_data;
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return server_tour_result;
  };

  return {
    getServerTourResult: _getServerTourResult,
    getServerTourResultByGetMethod: _getServerTourResultByGetMethod
  };
}
